import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import DropzoneComponent from 'react-dropzone-component';
import config from 'config';
import './UploadPrescription.scss';

const checkSource = (ev, props) => {
  const { addToCart, submitPowers } = props;
  if (!submitPowers) {
    addToCart(ev);
  }
};

const UploadPrescription = props => {
  const {
    fileUploadSuccess,
    imagePreviewUrl,
    uploadSuccess,
    uploadError,
    isPowerSubmitFailed,
    dataLocale: { UPLOAD_YOUR_PRESCRIPTION, POWER_NOT_SUBMITTED_SUCCESSFULLY, SAVE_AND_CONTINUE },
  } = props;
  const componentConfig = {
    iconFiletypes: ['.jpg', '.png', '.gif'],
    showFiletypeIcon: true,
    postUrl: config.apiPath.uploadprescfile,
  };
  const djsConfig = {
    paramName: 'myfile',
    addRemoveLinks: true,
    maxFilesize: 8,
    maxFiles: 1,
    uploadMultiple: false,
    acceptedFiles: 'image/jpeg,image/png,image/gif',
  };
  const eventHandlers = {
    success: fileUploadSuccess,
    processingmultiple: null,
    sendingmultiple: null,
    successmultiple: null,
    completemultiple: null,
    canceledmultiple: null,
  };
  useEffect(() => {
    if (typeof window.clevertap !== 'undefined') {
      window.clevertap.event.push('Page Visited', {
        pageName: 'Upload prescription page',
      });
    }
  }, []);
  return (
    <div className="uploadPresTab">
      <p className="upload-prescriptions-heading">{UPLOAD_YOUR_PRESCRIPTION}</p>
      {isPowerSubmitFailed && (
        <p className="alert alert-danger error-text text-center text-uppercase">
          {POWER_NOT_SUBMITTED_SUCCESSFULLY}
        </p>
      )}
      <div className="col-lg-12 col-md-12 col-sm-12">
        <DropzoneComponent
          config={componentConfig}
          djsConfig={djsConfig}
          eventHandlers={eventHandlers}
        />
        <form onSubmit={ev => checkSource(ev, props)}>
          {imagePreviewUrl !== '' ? (
            <button
              className="margin-t10 submit-btn submit-btn pull-right margin-b10"
              type="submit"
            >
              {SAVE_AND_CONTINUE}
            </button>
          ) : (
            ''
          )}
          {uploadSuccess !== null && uploadError === null && (
            <div className="file-upload-success text-topaz margin-t15 text-center fs14">
              {uploadSuccess}
            </div>
          )}
          {!uploadSuccess && uploadError !== null && (
            <div className="file-upload-error text-color-red margin-t15 text-center fs14">
              {uploadError}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  dataLocale: state.locale,
});

export default connect(mapStateToProps, null)(UploadPrescription);
